import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { Button } from './Button';
const deliverables = [{
  title: 'El Manual Digital Completo',
  desc: 'Paso a paso para milanesas, minutas y guarniciones.',
  icon: CheckCircle2
}, {
  title: 'La Técnica del Rocío de Oro',
  desc: 'La mezcla exacta de aceites para el dorado perfecto.',
  icon: CheckCircle2
}, {
  title: 'Matriz de Tiempos Criollos',
  desc: 'Tabla de conversión rápida para que no adivines más.',
  icon: CheckCircle2
}, {
  title: 'Guía de Rescate del Freezer',
  desc: 'Cómo hacer que lo congelado parezca recién hecho.',
  icon: CheckCircle2
}, {
  title: 'Bonus Exclusivo',
  desc: 'El secreto para recalentar facturas que parecen de panadería.',
  icon: Gift,
  isBonus: true
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="bg-charcoal-light py-24 px-6 md:px-12" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-118">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-119">
            Lo que te llevás hoy
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-4 mb-16" data-id="element-120">
          {deliverables.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} variants={itemVariants} className={`p-6 md:p-8 rounded-2xl flex items-center space-x-6 ${item.isBonus ? 'bg-amber/10 border border-amber/30' : 'bg-charcoal border border-white/5'}`} data-id="element-121">
                <div className={`flex-shrink-0 ${item.isBonus ? 'text-amber' : 'text-amber-light'}`} data-id="element-122">
                  <Icon size={32} data-id="element-123" />
                </div>
                <div data-id="element-124">
                  <h3 className="font-serif font-bold text-xl text-cream mb-1" data-id="element-125">
                    {item.isBonus ? <span className="text-amber uppercase text-sm tracking-wider block mb-1" data-id="element-126">
                        Bonus
                      </span> : null}
                    {item.title}
                  </h3>
                  <p className="font-sans text-cream/70" data-id="element-127">{item.desc}</p>
                </div>
              </motion.div>;
        })}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-128">
          <Button onClick={() => window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
        })} data-id="element-129">
            ¡QUIERO MI COPIA AHORA!
          </Button>
        </motion.div>
      </div>
    </section>;
}